/**
 * @mynaui/icons-react v0.3.1 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var CogThree = createReactComponent("cog-three", "CogThree", [["path", { "d": "M8.4 18.235a7.2 7.2 0 0 0 7.2-12.47m-7.2 12.47A7.2 7.2 0 0 1 5.765 8.4M8.4 18.235l-.9 1.56m8.1-14.03A7.2 7.2 0 0 0 5.765 8.4M15.6 5.765l.9-1.56M5.765 8.4l-1.56-.9m10.295 6 5.294 3M12 21v-1.8M12 9V3m4.5 16.794-.899-1.558m-8.1-14.03.898 1.558M20.999 12h-1.798m-16.2 0h1.798m14.995-4.5-1.558.899M9.5 13.5l-5.294 3", "key": "svg-0" }], ["path", { "d": "M14.5 12a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0", "key": "svg-1" }]]);

export { CogThree as default };
//# sourceMappingURL=CogThree.js.map
